module.exports = __webpack_public_path__ + "img/result-detail-invest-outright02.571ec315.svg";